import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <GoogleOAuthProvider clientId="1086958466350-mbbjpjs5ppn95jil9801rrlq4mp1vrev.apps.googleusercontent.com">
      <App />
      </GoogleOAuthProvider>
);

